import ApplicationConfigurationEditor from './application-configuration-editor';

export default ApplicationConfigurationEditor;
